import {type FC} from 'react';
import {styled} from 'styled-components';

import {UnthemedNavLink} from '@shared_web/components/core/button';
import {SvgIcon} from '@shared_web/components/core/svg_icon';
import {icon_bell_fill} from '@shared_web/components/icons/icon_bell_fill';
import {ZINDEX} from '@shared_web/lib/zindex';

import {icon_account_circle} from '@mavismart_frontend/icons/icon_account_circle';
import {icon_bell} from '@mavismart_frontend/icons/icon_bell';
import {icon_home_white} from '@mavismart_frontend/icons/icon_home_white';
import {icon_mavismart_logo_white} from '@mavismart_frontend/icons/icon_mavismart_logo_white';
import {icon_search_white} from '@mavismart_frontend/icons/icon_search_white';
import {HEADER_HEIGHT, MAIN_COLOR} from '@mavismart_frontend/lib/constants';
import {useHasUnreadNotifications} from '@mavismart_frontend/stores/notifications_store';

export const Header: FC = () => {
  const hasNotifications = useHasUnreadNotifications();

  return (
    <Wrapper>
      <WrapperRight>
        <WrapperHome>
          <UnthemedNavLink to="/">
            <SvgIcon icon={icon_home_white} color="transparent" />
          </UnthemedNavLink>
        </WrapperHome>
        <UnthemedNavLink to="/search">
          <SvgIcon icon={icon_search_white} color="transparent" />
        </UnthemedNavLink>
        <Gap>
          <UnthemedNavLink to="/">
            <SvgIcon icon={icon_mavismart_logo_white} height={HEADER_HEIGHT * 0.6} />
          </UnthemedNavLink>
        </Gap>

        <UnthemedNavLink to="/user/notifications">
          <BellWrapper>
            <SvgBellItem
              icon={hasNotifications ? icon_bell_fill : icon_bell}
              color="white"
              className={hasNotifications ? 'has-notifications' : ''}
            />
          </BellWrapper>
        </UnthemedNavLink>
        <UnthemedNavLink to="/user/account">
          <SvgIcon icon={icon_account_circle} />
        </UnthemedNavLink>
      </WrapperRight>
    </Wrapper>
  );
};

Header.displayName = 'Header';

const Gap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  font-size: 18px;
`;

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  z-index: ${ZINDEX.Header};
  height: calc(${HEADER_HEIGHT}px + env(safe-area-inset-top));
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: ${MAIN_COLOR};
  color:  white;
  padding: env(safe-area-inset-top) 16px 0 16px;
  padding-left: calc(16px + env(safe-area-inset-left) / 2);
  padding-right: calc(16px + env(safe-area-inset-right) / 2);
`;

const WrapperRight = styled.div`
  display: flex;
  gap: 20px;
  width:100%;
`;

const WrapperHome = styled.div`
  position: relative;
  display: flex;
  cursor: pointer;
`;

const SvgBellItem = styled(SvgIcon)`
  display: inline-block;

  &.has-notifications {
    animation: ring 2s ease-in-out infinite;
  }

  @keyframes ring {
    0%, 100% {
      transform: rotate(0deg);
    }
    5%, 15% {
      transform: rotate(-15deg);
    }
    10%, 20% {
      transform: rotate(15deg);
    }
    25% {
      transform: rotate(0deg);
    }
  }
`;

const BellWrapper = styled.div`
  position: relative;
  margin-top: 4px;
`;
